<template>
  <section class="locations-list">
    <div v-if="!locationsList.length">
      <no-location />
    </div>
    <div
      v-else
      class="column"
    >
      <div class="field">
        <div class="control">
          <div class="select">
            <div class="select-container w-1/4">
              <select
                v-model="location"
                class="al-select"
                :disabled="!locationsList.length"
                @change="handleLocationChange"
              >
                <option
                  selected
                  disabled
                  hidden
                  value=""
                >
                  Choose your location ...
                </option>
                <template v-for="(location) in locationsList">
                  <option
                    :key="location.uuid + Math.random()"
                    :value="location.uuid"
                  >
                    {{ location.name }}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import NoLocation from './NoLocation.vue';
import UserService from '../../services/user.service';
import { Routes, Roles } from '../../constants';
import DashboardService from '../../services/dashboard.service';

const userService = new UserService();
const dashboardService = new DashboardService();

export default {
  name: 'LocationsList',
  components: {
    NoLocation
  },
  data() {
    return {
      routes: Routes,
      role: this.$store.state.user.role,
      roles: Roles,
      locationsReady: !!this.$store.state.locationsList.length,
      location: '',
      locationRequested: false
    };
  },
  computed: {
    locationsList() {
      const locations = this.$store.state.locationsList;
      if (!this.locationRequested && (!locations || !locations.length)) {
        this.getLocations();
      }
      return locations;
    },
    selectedOrganization() {
      return this.$store.state.organization;
    }
  },
  watch: {
    locationsList(newLocations) {
      this.locationsReady = !!newLocations.length;
      if (this.locationsReady && newLocations && newLocations.length) {
        const lastSelectedLocationUuid = localStorage.getItem('lastSelectedLocationUuid');
        const uuid = lastSelectedLocationUuid || newLocations[0].uuid;
        this.setLocation(uuid);

        if (lastSelectedLocationUuid && this.locationRequested) {
          localStorage.removeItem('lastSelectedLocationUuid');
        }
      }
    }
  },
  mounted() {
    this.getLocations();
  },
  methods: {
    handleLocationChange() {
      const { location } = this;
      this.setEmployeeData(location);
      this.$emit('location-change', location);
    },
    setSelectedLocation(uuid) {
      this.location = uuid;
    },
    getLocations() {
      const organization = { ...this.selectedOrganization };

      if (this.role === this.roles.SUPER_ADMIN && (!organization || !Object.keys(organization).length)) {
        this.$store.commit('setLocationsList', { result: [] });
        return;
      }

      if (!this.locationRequested) {
        const self = this;

        userService.getLocations(this.$store.state.user.role, organization.uuid)
          .then((resp) => {
            const locationsData = resp.data;
            const { status, result } = locationsData;

            if (status === 'success') {
              if (result?.length) {
                self.$store.commit('setLocationsList', { result: [...result] });
                self.setLocation();
              }
            } else {
              self.$root.$emit('showToast', { message: 'Impossible to find your location info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
            }
          })
          .catch(() => {
            self.$root.$emit('showToast', { message: 'Impossible to find your location info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
          })
          .finally(() => {
            setTimeout(() => {
              self.locationRequested = true;
            }, 0);
          });
      }
    },
    setLocation(uuid) {
      if (uuid && this.locationsReady) {
        this.setSelectedLocation(uuid);
        this.handleLocationChange(uuid);
      }
    },
    setEmployeeData(uuid) {
      const self = this;

      dashboardService.getEmployeeCompany(uuid)
        .then((response) => {
          const { data } = response;

          if (data.status === 'success') {
            self.$store.commit('setEmployeeData', response.data);
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to find your employee info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Technical issue. Please try again later', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    }
  }
};
</script>
<style scoped lang="scss">
    .locations-list {
        margin: 10px 0;

        .column {
            padding: 10px 0;
        }
    }
</style>
